import { escape, get } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets } from '@/utils'

import render from './render'

export default {
  name: 'FileOwner',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    readonly: Boolean
  },

  computed: {
    id() {
      return get(this.value, 'Owner.id')
    },
    username() {
      return get(this.value, 'Owner.username')
    },
    name() {
      const { firstName, lastName } = get(this.value, 'Owner.data', {})
      const name = [ firstName, lastName ].filter(Boolean).map(escape).join(' ')

      return [ this.username, name ].filter(Boolean).join('\n')
    },
    verified() {
      return get(this.value, 'Owner.$verified')
    },
    canGetUsersAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    }
  },

  render
}
